import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { useGetFollows } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import type { SWRResponse } from "swr"
import useSWR from "swr"

import { useFollowsSWRKey } from "./useFollowsSWRKey"

export function useFollows(): SWRResponse<Array<Follow>> {
  const followsSWRKey = useFollowsSWRKey()
  const getFollows = useGetFollows()

  const getFollowsData = useMemo(
    () => !getFollows ? null : (async () => {
      const response = await getFollows({ params: {} })
      return response
    }),
    [getFollows],
  )

  return useSWR<Array<Follow>>(
    followsSWRKey,
    getFollowsData,
  )
}
